// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1960":"c9e69939","4214":"93208ab6","5751":"56772bb1","8110":"2647006b","8330":"c9e69939","8708":"67ab4d30","8764":"88a5467e"}[chunkId] + ".chunk.css";
};